(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 48312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(45784);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 45784:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useQuery.js + 2 modules
var useQuery = __webpack_require__(6812);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(11752);
var config_default = /*#__PURE__*/__webpack_require__.n(config);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/uuid/dist/esm-browser/v4.js + 3 modules
var v4 = __webpack_require__(57632);
// EXTERNAL MODULE: ./hooks/useFormat.ts + 1 modules
var useFormat = __webpack_require__(29397);
// EXTERNAL MODULE: ./modules/modules.tsx + 154 modules
var modules = __webpack_require__(99425);
// EXTERNAL MODULE: ./src/api/widgets.ts
var api_widgets = __webpack_require__(71877);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js + 1 modules
var styled = __webpack_require__(56513);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./src/settings/widgets/provider/WidgetImagesProvider.tsx
var WidgetImagesProvider = __webpack_require__(43514);
// EXTERNAL MODULE: ./src/components/dashboard/DesktopDashboard.tsx + 1 modules
var DesktopDashboard = __webpack_require__(64770);
// EXTERNAL MODULE: ./src/components/session/SessionContext.tsx
var SessionContext = __webpack_require__(40947);
;// CONCATENATED MODULE: ./src/components/homepage/DesktopHomepage.tsx






var InfoWrapper = (0,styled/* default */.ZP)("div")(function(param) {
    var spacing = param.theme.spacing;
    return {
        height: "100%",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        gap: spacing(2)
    };
});
var DesktopHomepage = function(param) {
    var widgetsWithKey = param.widgetsWithKey, loading = param.loading;
    var ref = (0,SessionContext/* useSession */.k)(), sessionCustomerFile = ref.customerFile;
    var publicRuntimeConfig = config_default()().publicRuntimeConfig;
    var standaloneModule = publicRuntimeConfig.standaloneModule;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            !sessionCustomerFile && /*#__PURE__*/ (0,jsx_runtime.jsxs)(InfoWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "h6",
                        children: "Aucun dossier"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "body2",
                        children: "Aucun dossier client n'est disponible"
                    })
                ]
            }),
            sessionCustomerFile && !standaloneModule ? /*#__PURE__*/ (0,jsx_runtime.jsx)(WidgetImagesProvider/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DesktopDashboard/* default */.Z, {
                    widgetsWithKey: widgetsWithKey,
                    loading: loading
                })
            }) : null
        ]
    });
};
/* harmony default export */ var homepage_DesktopHomepage = (DesktopHomepage);

// EXTERNAL MODULE: ./node_modules/@mui/material/Stack/Stack.js
var Stack = __webpack_require__(26447);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/@mui/material/CircularProgress/CircularProgress.js + 1 modules
var CircularProgress = __webpack_require__(98456);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@elipssolution/harfang/dist/esm/index.js + 1 modules
var esm = __webpack_require__(75906);
// EXTERNAL MODULE: ./node_modules/@mdi/js/mdi.js
var mdi = __webpack_require__(55317);
// EXTERNAL MODULE: ./node_modules/@mui/material/Paper/Paper.js + 2 modules
var Paper = __webpack_require__(90629);
// EXTERNAL MODULE: ./src/hooks/useCustomRouter.ts
var useCustomRouter = __webpack_require__(24763);
// EXTERNAL MODULE: ./src/widgets/widgets.ts + 137 modules
var widgets = __webpack_require__(72844);
;// CONCATENATED MODULE: ./src/components/dashboard/item/MobileDashboardItem.tsx









var StyledDashboardItem = (0,styled/* default */.ZP)(Paper/* default */.Z)(function(param) {
    var _theme = param.theme, palette = _theme.palette, shape = _theme.shape;
    return {
        border: "1px solid ".concat(palette.divider),
        borderRadius: shape.borderRadius * 2,
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        width: "100%",
        height: "100%"
    };
});
var MobileDashboardItem = function(param) {
    var widgetWithKey = param.widgetWithKey;
    var widget = widgetWithKey.widget;
    var ref = (0,useCustomRouter/* default */.Z)(), push = ref.push, query = ref.query;
    var name = widget.name, type = widget.type, configuration = widget.configuration;
    var ref1 = (0,widgets/* getWidgetTemplateByType */.M)(type), WidgetComponent = ref1.component, expandedComponent = ref1.expandedComponent;
    var parsedConfiguration = (0,react.useMemo)(function() {
        return configuration ? JSON.parse(configuration) : undefined;
    }, [
        configuration
    ]);
    var handleNavigateToWidget = (0,react.useCallback)(function() {
        push({
            pathname: "widget",
            query: (0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, query), {
                name: name,
                type: type
            }), configuration && {
                configuration: configuration
            })
        }).catch(function(error) {
            throw error;
        });
    }, [
        configuration,
        name,
        push,
        query,
        type
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledDashboardItem, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                direction: "row",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        padding: 1,
                        flex: 1,
                        variant: "h6",
                        fontSize: "18px",
                        noWrap: true,
                        children: name
                    }),
                    expandedComponent && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* IconButton */.hU, {
                        onClick: handleNavigateToWidget,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Icon */.JO, {
                            path: mdi/* mdiArrowExpand */.b6e
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                flex: 1,
                padding: 1,
                paddingTop: 0,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WidgetComponent, {
                    widgetWithKey: widgetWithKey,
                    configuration: parsedConfiguration,
                    readOnly: false
                })
            })
        ]
    });
};
/* harmony default export */ var item_MobileDashboardItem = (MobileDashboardItem);

// EXTERNAL MODULE: ./node_modules/react-grid-layout/css/styles.css
var styles = __webpack_require__(58834);
// EXTERNAL MODULE: ./node_modules/react-resizable/css/styles.css
var css_styles = __webpack_require__(50510);
// EXTERNAL MODULE: ./utils/widgets.ts
var utils_widgets = __webpack_require__(94461);
;// CONCATENATED MODULE: ./src/components/dashboard/MobileDashboard.tsx







var StyledContainer = (0,styled/* default */.ZP)("div")(function(param) {
    var spacing = param.theme.spacing;
    return {
        border: "none",
        display: "flex",
        flexDirection: "column",
        gap: spacing(2),
        paddingTop: spacing(2),
        flex: 1
    };
});
var MobileDashboard_InfoWrapper = (0,styled/* default */.ZP)("div")({
    flex: 1,
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
});
var widgetTypeOrder = [
    utils_widgets/* WidgetEnum.DOCUMENT_UPLOAD */.j.DOCUMENT_UPLOAD,
    utils_widgets/* WidgetEnum.HTML */.j.HTML,
    utils_widgets/* WidgetEnum.EXTERNAL_APPLICATIONS */.j.EXTERNAL_APPLICATIONS,
    utils_widgets/* WidgetEnum.SIMULATORS */.j.SIMULATORS,
    utils_widgets/* WidgetEnum.DOCUMENT_LAST_UPLOADS */.j.DOCUMENT_LAST_UPLOADS,
    utils_widgets/* WidgetEnum.CHART */.j.CHART,
    utils_widgets/* WidgetEnum.CONTACT */.j.CONTACT, 
];
var MobileDashboard = function(param) {
    var _widgetsWithKey = param.widgetsWithKey, widgetsWithKey = _widgetsWithKey === void 0 ? [] : _widgetsWithKey, _loading = param.loading, loading = _loading === void 0 ? false : _loading;
    var sortedWidgetsWithKey = (0,react.useMemo)(function() {
        if (widgetsWithKey.length === 0) return null;
        return widgetsWithKey.sort(function(a, b) {
            return widgetTypeOrder.indexOf(a.widget.type) - widgetTypeOrder.indexOf(b.widget.type);
        }).map(function(widgetWithKey) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(item_MobileDashboardItem, {
                    widgetWithKey: widgetWithKey
                })
            }, widgetWithKey.key);
        });
    }, [
        widgetsWithKey
    ]);
    return loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileDashboard_InfoWrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
            size: 36,
            color: "inherit"
        })
    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledContainer, {
        children: [
            widgetsWithKey.length === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileDashboard_InfoWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "h6",
                    children: "Aucun widget"
                })
            }),
            sortedWidgetsWithKey
        ]
    });
};
/* harmony default export */ var dashboard_MobileDashboard = (MobileDashboard);

// EXTERNAL MODULE: ./src/components/LogoProvider.tsx
var LogoProvider = __webpack_require__(45352);
;// CONCATENATED MODULE: ./src/components/homepage/MobileHomepage.tsx









var MobileHomepage_InfoWrapper = (0,styled/* default */.ZP)("div")(function(param) {
    var spacing = param.theme.spacing;
    return {
        height: "100%",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        gap: spacing(2)
    };
});
var MobileHomepage = function(param) {
    var widgetsWithKey = param.widgetsWithKey, loading = param.loading;
    var ref = (0,SessionContext/* useSession */.k)(), sessionCustomerFile = ref.customerFile;
    var publicRuntimeConfig = config_default()().publicRuntimeConfig;
    var standaloneModule = publicRuntimeConfig.standaloneModule;
    var logo = (0,LogoProvider/* useLogo */.u)().logo;
    var ref1 = (0,react.useState)(), logoUrl = ref1[0], setLogoUrl = ref1[1];
    (0,react.useEffect)(function() {
        return setLogoUrl(function(prevValue) {
            if (prevValue) URL.revokeObjectURL(prevValue);
            return logo && URL.createObjectURL(logo);
        });
    }, [
        logo
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            !sessionCustomerFile && /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileHomepage_InfoWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "h6",
                    children: "Aucun dossier"
                })
            }),
            sessionCustomerFile && !standaloneModule ? /*#__PURE__*/ (0,jsx_runtime.jsx)(WidgetImagesProvider/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                    flex: 1,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                            py: 2,
                            justifyContent: "center",
                            alignItems: "center",
                            children: logoUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: logoUrl,
                                loader: function(param) {
                                    var src = param.src;
                                    return src;
                                },
                                alt: "logo",
                                width: 250,
                                height: 78,
                                objectFit: "contain",
                                unoptimized: true
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dashboard_MobileDashboard, {
                            widgetsWithKey: widgetsWithKey,
                            loading: loading
                        })
                    ]
                })
            }) : null
        ]
    });
};
/* harmony default export */ var homepage_MobileHomepage = (MobileHomepage);

;// CONCATENATED MODULE: ./src/pages/index.tsx















var Homepage = function() {
    var isMobileFormat = (0,useFormat/* default */.Z)().isMobileFormat;
    var ref = (0,SessionContext/* useSession */.k)(), sessionCustomerFile = ref.customerFile, checkPermission = ref.checkPermission;
    var publicRuntimeConfig = config_default()().publicRuntimeConfig;
    var standaloneModule = publicRuntimeConfig.standaloneModule;
    var ref1 = (0,useCustomRouter/* default */.Z)(), replace = ref1.replace, query = ref1.query;
    var ref2 = (0,useQuery/* useQuery */.aM)(api_widgets/* FETCH_WIDGETS */.J, {
        skip: !!standaloneModule
    }), widgetData = ref2.data, loading = ref2.loading;
    var widgets = (widgetData !== null && widgetData !== void 0 ? widgetData : {}).widgets;
    var widgetsWithKey = (0,react.useMemo)(function() {
        return widgets === null || widgets === void 0 ? void 0 : widgets.flatMap(function(widget) {
            return isMobileFormat && widget.isAvailableOnMobileFormat || !isMobileFormat && widget.isAvailableOnDesktopFormat ? {
                key: (0,v4/* default */.Z)(),
                widget: widget
            } : [];
        });
    }, [
        isMobileFormat,
        widgets
    ]);
    var navigateToRoute = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
            var route, subItems, ref, ref1, ref2, firstAllowedSubItemRoute, subSubItems, newPathnameArray;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        route = param.route, subItems = param.subItems;
                        ref2 = (ref1 = subItems === null || subItems === void 0 ? void 0 : subItems.find(function(param) {
                            var permissionCodes = param.permissionCodes;
                            return (ref = permissionCodes === null || permissionCodes === void 0 ? void 0 : permissionCodes.some(checkPermission)) !== null && ref !== void 0 ? ref : true;
                        })) !== null && ref1 !== void 0 ? ref1 : {}, firstAllowedSubItemRoute = ref2.route, subSubItems = ref2.subItems;
                        newPathnameArray = (0,_to_consumable_array/* default */.Z)(route.split("/")).concat([
                            firstAllowedSubItemRoute === null || firstAllowedSubItemRoute === void 0 ? void 0 : firstAllowedSubItemRoute.replace(/^\//, "")
                        ]).filter(function(item) {
                            return !!item && (standaloneModule ? item !== standaloneModule : true);
                        });
                        if (!(subSubItems && firstAllowedSubItemRoute)) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            navigateToRoute({
                                route: "/".concat(newPathnameArray.join("/")),
                                subItems: subSubItems
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                    case 2:
                        return [
                            4,
                            replace({
                                pathname: "/".concat(newPathnameArray.join("/")),
                                query: query
                            })
                        ];
                    case 3:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), [
        checkPermission,
        query,
        replace,
        standaloneModule
    ]);
    (0,react.useEffect)(function() {
        if (standaloneModule && !!sessionCustomerFile) {
            var foundStandaloneModule = modules/* default.find */.Z.find(function(param) {
                var code = param.code;
                return code === standaloneModule;
            });
            if (foundStandaloneModule) {
                navigateToRoute({
                    route: foundStandaloneModule.route,
                    subItems: foundStandaloneModule.subItems
                }).catch(function(error) {
                    throw error;
                });
            }
        }
    }, [
        sessionCustomerFile,
        standaloneModule,
        navigateToRoute
    ]);
    return isMobileFormat ? /*#__PURE__*/ (0,jsx_runtime.jsx)(homepage_MobileHomepage, {
        widgetsWithKey: widgetsWithKey,
        loading: loading
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(homepage_DesktopHomepage, {
        widgetsWithKey: widgetsWithKey,
        loading: loading
    });
};
/* harmony default export */ var pages = (Homepage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(48312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);